import { render, staticRenderFns } from "./Vibe.vue?vue&type=template&id=73071d38&scoped=true&lang=pug&"
import script from "./Vibe.vue?vue&type=script&lang=js&"
export * from "./Vibe.vue?vue&type=script&lang=js&"
import style0 from "./Vibe.vue?vue&type=style&index=0&id=73071d38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73071d38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
